'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var globals = require('../../../utils/globals.js');
var LoaderContent = require('../../01.atoms/LoaderContent/LoaderContent.js');
var dynamic = require('../../../utils/dynamic/dynamic.js');
require('./_index.scss.js');

var _excluded = ["type"];
var TeaserArticle = dynamic(function () {
  return new Promise(function (resolve) { resolve({ 'default': require('../../02.molecules/TeaserArticle/TeaserArticle.js') }); });
}, {
  loading: function loading() {
    return /*#__PURE__*/React__default.createElement(LoaderContent, {
      contentPlaceholder: true,
      delay: 0
    });
  }
});
var TeaserProfile = dynamic(function () {
  return new Promise(function (resolve) { resolve({ 'default': require('../../02.molecules/TeaserProfile/TeaserProfile.js') }); });
}, {
  loading: function loading() {
    return /*#__PURE__*/React__default.createElement(LoaderContent, {
      contentPlaceholder: true,
      delay: 0
    });
  }
});
var TeaserBox = dynamic(function () {
  return new Promise(function (resolve) { resolve({ 'default': require('../../02.molecules/TeaserBox/TeaserBox.js') }); });
}, {
  loading: function loading() {
    return /*#__PURE__*/React__default.createElement(LoaderContent, {
      contentPlaceholder: true,
      delay: 0
    });
  }
});
var CLASSNAME = 'varta-grid-teaser',
    cnPadding = "".concat(CLASSNAME, "--padding"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnTable = "".concat(CLASSNAME, "__table"),
    cnRow = "".concat(CLASSNAME, "__row"),
    cnCell = "".concat(CLASSNAME, "__cell"),
    cnCellPadding = "".concat(cnCell, "--padding"),
    cnCellContainer = "".concat(cnCell, "__container");
/**
 * 
 */

var GridTeaser = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(GridTeaser, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(GridTeaser);

  function GridTeaser() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, GridTeaser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "wrapper", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onScroll", function () {
      if (!_this.ticking) {
        requestAnimationFrame(_this.update);
      }

      _this.ticking = true;
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "update", function () {
      var _this$props = _this.props,
          offset = _this$props.offset,
          onScrollBottom = _this$props.onScrollBottom,
          box = _this.wrapper.current.getBoundingClientRect(),
          _window = window,
          innerHeight = _window.innerHeight;

      if (box.bottom - innerHeight < offset && onScrollBottom) {
        onScrollBottom();
      }

      _this.ticking = false;
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(GridTeaser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onScrollBottom = this.props.onScrollBottom;

      if (onScrollBottom) {
        window.addEventListener('scroll', this.onScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "getTeaser",
    value:
    /**
     * Returns the right type of teaser
     *
     * @param param
     * @param {String} param.type - Teaser type
     * @returns {*} JSX element
     */
    function getTeaser(teaser) {
      var type = teaser.type,
          rest = _rollupPluginBabelHelpers.objectWithoutProperties(teaser, _excluded);

      var _this$props2 = this.props,
          breakpoint = _this$props2.breakpoint,
          articles = _this$props2.articles;

      if (articles) {
        return /*#__PURE__*/React__default.createElement(TeaserArticle, _rollupPluginBabelHelpers.extends({
          breakpoint: breakpoint
        }, rest));
      }

      if (type === 'TeaserProfile') {
        return /*#__PURE__*/React__default.createElement(TeaserProfile, _rollupPluginBabelHelpers.extends({
          breakpoint: breakpoint
        }, rest));
      }

      if (teaser.node && /*#__PURE__*/React__default.isValidElement(teaser.node)) {
        return teaser.node;
      }

      return /*#__PURE__*/React__default.createElement(TeaserBox, _rollupPluginBabelHelpers.extends({
        breakpoint: breakpoint
      }, rest));
    }
  }, {
    key: "getDefinedBreakpoint",
    value:
    /**
     * Checks if `object[breakpoint]` exists. If not, looks for the next smaller defined breakpoint.
     *
     * @param {Object} object
     * @param {String} breakpoint - Functions as a upper limit while looking for a breakpoint
     *
     * @returns {String} Returns the biggest possible breakpoint that is defined in `object`.
     */
    function getDefinedBreakpoint(obj, breakpoint) {
      var keys = Object.keys(globals.breakpoints);
      var index = keys.indexOf(breakpoint);

      if (index < 0) {
        index = keys.length;
      }

      return typeof obj[breakpoint] === 'number' ? breakpoint : keys.slice(0, index).reverse().find(function (key) {
        return typeof obj[key] === 'number';
      });
    }
    /**
     * Get horizontal width of `item`
     *
     * @param {Object} item
     * @param {String} breakpoint - Active breakpoint
     * @param {Number=12} defaultCols - Fallback value
     */

  }, {
    key: "getColWidth",
    value: function getColWidth(item, breakpoint) {
      var defaultCols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;

      if (!item.col) {
        return defaultCols;
      }

      var width = item.col[this.getDefinedBreakpoint(item.col, breakpoint)];
      return typeof width === 'number' ? width : defaultCols;
    }
    /**
     * Get vertical width of `item`
     *
     * @param {Object} item
     * @param {String} breakpoint - Active breakpoint
     * @param {Number=1} defaultRows - Fallback value
     */

  }, {
    key: "getRowWidth",
    value: function getRowWidth(item, breakpoint) {
      var defaultRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (!item.row) {
        return defaultRows;
      }

      return item.row[this.getDefinedBreakpoint(item.row, breakpoint)] || defaultRows;
    }
    /**
     * Group items into rows.
     * Each row can be filled with items until the sum of columns is 12.
     * If an item has a row-span of greater than 1,
     * it will be considered in the filling of following rows.
     *
     * @returns {Array<Array>} Array to fake a CSS-Grid with a table-element
     */

  }, {
    key: "groupItems",
    value: function groupItems() {
      var _this2 = this;

      var _this$props3 = this.props,
          data = _this$props3.data,
          breakpoint = _this$props3.breakpoint,
          fillLast = _this$props3.fillLast;
      /** Each top-level element respresents a row.
       * Each element within this array represents a cell:
       * ```
       * [
       *   [cell, cell, cell] // 1st row
       *   [cell, cell, cell] // 2nd row
       * ]
       * ```
       * */

      var result = [[]];
      /** Max. columns */

      var gridColumns = 12;
      /** Store item if it spans over more than one row. */

      var previousItem = {
        col: {},
        count: 0
      };
      /** Sum of all column-width of the current row */

      var colSum = 0;
      /** Number of rows */

      var numOfRows = result.length;
      data.forEach(function (item, index) {
        // clear previous item, if row-span no longer affects current row
        if (previousItem.endIndex <= numOfRows) {
          previousItem = {
            col: {},
            count: 0
          };
        } // add width of previous item, if appropriate


        if (previousItem.startIndex < numOfRows) {
          colSum += _this2.getColWidth(previousItem, breakpoint, 0);
        } // create new element/row if previous row is full


        if (colSum + _this2.getColWidth(item, breakpoint) > gridColumns) {
          result.push([]);
          colSum = 0;
          numOfRows = result.length;

          if (colSum + _this2.getColWidth(item, breakpoint, 0) + (previousItem.count ? _this2.getColWidth(previousItem, breakpoint, 0) : 0) > gridColumns) {
            // add empty row if row span pushes next item
            result.push([]);
          }
        }

        previousItem.count += 1; // get last element (current row)

        var element = result[result.length - 1];
        element.push(item); // fill remaining space in last row

        if (index === data.length - 1 && fillLast && item.col) {
          item.col[breakpoint] = gridColumns - colSum;
        } // append width of last item


        var width = _this2.getColWidth(item, breakpoint);

        colSum += width; // store item if it affects upcoming rows due to rowSpan > 1

        if (_this2.getRowWidth(item, breakpoint) > 1 && width) {
          previousItem = item;
          previousItem.endIndex = numOfRows + _this2.getRowWidth(previousItem, breakpoint);
          previousItem.startIndex = numOfRows;
          previousItem.count = 0;
        }
      });
      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          title = _this$props4.title,
          loading = _this$props4.loading,
          breakpoint = _this$props4.breakpoint,
          articles = _this$props4.articles;
      var items = this.groupItems();
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(React.Suspense, {
        fallback: /*#__PURE__*/React__default.createElement(LoaderContent, null)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(className, CLASSNAME, _rollupPluginBabelHelpers.defineProperty({}, cnPadding, articles)),
        ref: this.wrapper
      }, title && /*#__PURE__*/React__default.createElement("h1", {
        className: cnTitle
      }, title), /*#__PURE__*/React__default.createElement("table", {
        className: cnTable
      }, /*#__PURE__*/React__default.createElement("tbody", null, items.map(function (group, i) {
        return /*#__PURE__*/React__default.createElement("tr", {
          key: i,
          className: cnRow
        }, group.map(function (item, j) {
          return _this3.getColWidth(item, breakpoint) === 0 ? null : /*#__PURE__*/React__default.createElement("td", {
            key: j,
            className: classNames(cnCell, _rollupPluginBabelHelpers.defineProperty({}, cnCellPadding, articles)),
            colSpan: _this3.getColWidth(item, breakpoint),
            rowSpan: _this3.getRowWidth(item, breakpoint, null)
          }, /*#__PURE__*/React__default.createElement("div", {
            className: cnCellContainer
          }, _this3.getTeaser(item)));
        }));
      }))), loading && /*#__PURE__*/React__default.createElement(LoaderContent, null))));
    }
  }]);

  return GridTeaser;
}(React__default.Component);
GridTeaser.propTypes = {
  /** True if all teasers are article teasers displayed with a padding */
  articles: PropTypes.bool,

  /** Styling breakpoints */
  breakpoint: PropTypes.oneOf(Object.keys(globals.breakpoints)),

  /** Additional class name */
  className: PropTypes.string,

  /** Array of objects containing grid data */
  data: PropTypes.array.isRequired,

  /** Expand last teaser to completely fill the last row */
  fillLast: PropTypes.bool,

  /** Lazy loading state */
  loading: PropTypes.bool,

  /** Offset for lazy loading */
  offset: PropTypes.number,

  /** triggered if user scrolls to bottom of component */
  onScrollBottom: PropTypes.func,

  /** Title */
  title: PropTypes.string
};
GridTeaser.defaultProps = {
  offset: 300,
  data: [],
  fillLast: true
};

module.exports = GridTeaser;
